var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJobSite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 590 590",
    enableBackground: "new 0 0 590 590",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FC0303",
    d: "M473.5,180.3c0.9,31.8-7.4,59.9-20.4,86.7c-12.3,25.4-25.3,50.5-37.4,76.1c-14.5,30.6-29.4,61.3-44.5,91.7 c-14.9,30.1-29.2,60.4-44,90.5c-9.2,18.9-18,37.9-27.2,56.8c-0.7,1.4-0.7,4-2.9,3.8c-2.1,0-2.4-2.4-3.1-4 C277.6,548,261,514.1,244.5,480c-13.3-27.5-26.8-55.2-40.3-82.7c-15.4-31.8-31.3-63.3-46-95.3c-9.3-20.2-20.6-39.5-27.7-60.7 c-5.2-15.6-8.3-31.3-9.3-47.9c-2.1-32.2,4.2-62.3,18.7-90.8c15.4-30.3,37.6-54.2,66.8-71.6c21.1-12.6,43.8-20.4,68.2-23.2 c26.3-3.1,51.9-1.4,77,6.9c23.7,7.8,44.8,20.2,63.7,37c29.1,25.8,46.4,58.1,54.9,95.3C472.9,158.1,475.2,170.1,473.5,180.3z  M297.5,86.3c-53.1-0.9-97.4,42.9-97.1,96.2c0.3,53.1,41,96.7,97.1,96.7c52.4,0,93.8-40.1,96.2-92.9 C396.3,130.1,349,85.3,297.5,86.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M297.8,86.3c51.6-1,98.8,43.8,96.2,100c-2.4,52.8-43.8,92.9-96.2,92.9c-55.9,0-96.7-43.6-97.1-96.7 C200.4,129.2,244.7,85.4,297.8,86.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobSite);
export default __webpack_public_path__ + "static/media/job-site.3a3d8f963677be2810d42b10a1d5d87d.svg";
export { ForwardRef as ReactComponent };